(function() {
  const OVERLAYS = '.cart-drawer__overlay, .drawer__overlay, .modal-overlay';

  function unlockPage() {
    document.documentElement.classList.remove('js-drawer-open','overflow-hidden');
    document.body.style.overflow = '';
    document.querySelectorAll(OVERLAYS).forEach(el => {
      el.style.pointerEvents = 'none';
      el.style.opacity = '0';
    });
  }

  function isDrawerTrulyOpen() {
    const d = document.querySelector('cart-drawer, .cart-drawer, .drawer');
    if (!d) return false;
    return d.hasAttribute('open') || d.classList.contains('is-open') || d.getAttribute('aria-hidden') === 'false';
  }

  setInterval(() => {
    const ov = document.querySelector(OVERLAYS);
    if (!ov) return;
    const rect = ov.getBoundingClientRect ? ov.getBoundingClientRect() : { width: 0, height: 0 };
    const visible = (rect.width > 0 && rect.height > 0) || ov.offsetParent !== null;
    if (visible && !isDrawerTrulyOpen()) unlockPage();
  }, 1200);

  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') unlockPage();
  }, { passive: true });
})();